import { getSite } from '@/utils/index';
import { BRANDS, SECTION } from 'lib/data/video/types';

export interface Config {
  frontPage: {
    sections: SECTION[];
    showsSectionTitle?: string;
    newsSectionTitle?: string;
    pageTitle?: string;
    trendingSectionTitle?: string;
    seoTitle?: string;
    seoDescription?: string;
    description?: string;
  };
  tagPage: {
    getDescription?: (tagName: string) => string;
  };
  showsPage: {
    headline?: string;
    description?: string;
    allShowSeoDescription?: string;
    getShowDefaultDescription?: (programName: string) => string;
    getShowSeoDescription?: (programName: string) => string;
  };
}

const DEFAULT_CONFIG: Config = {
  frontPage: {
    sections: ['new', 'shows', 'tags', 'trending'],
  },
  tagPage: {},
  showsPage: {
    headline: 'Våra program',
  },
};

export const VIDEO_PAGES_CONFIG: Config = ({
  [BRANDS.SVENSKDAM]: {
    frontPage: {
      sections: ['new', 'shows', 'tags', 'trending'],
      pageTitle: 'De senaste videoklippen från Svensk dam',
      newsSectionTitle: 'SENASTE VIDEOS',
      showsSectionTitle: 'KUNGLIGA PROGRAM',
      trendingSectionTitle: 'MEST SEDDA',
      seoTitle: 'Se alla videos om kungligt & kändis på Svensk Damtidning',
      seoDescription:
        'Upptäck alla videos på Svensk Dam – från samtal med våra hovexperter till senaste nytt om kändisar och kungligheter världen över',
      description:
        'Se de senaste kungliga nyheterna och lär dig mer om den svenska nöjesvärlden på Svensk Damtidnings videosida. Här kan du titta på allt från intervjuer med våra hovexperter till spännande tillbakablickar och färska nyheter med svenska och internationella kungligheter i fokus. Upptäck våra programserier och titta på mängder av spännande innehåll här.',
    },
    tagPage: {
      getDescription: (programName: string) =>
        `Här kan du se alla intervjuer och videos om ${programName}. Hos Svensk Dam hittar du det och mycket mer.`,
    },
    showsPage: {
      headline: 'Våra program',
      allShowSeoDescription:
        'Här hittar du alla program du kan se på Svensk Damtidning. Kanske vill du titta på En kunglig måltid där kungliga maträtter lagas av kockar eller varför inte Svensk Dam förklarar? Vi har såklart också program om både Nobel och Victoriadagen - här hittar du alla program på Svensk Dam!',
      description:
        'Här hittar du alla program du kan se på Svensk Damtidning. Kanske vill du titta på En kunglig måltid där kungliga maträtter lagas av kockar eller varför inte Svensk Dam förklarar? Vi har såklart också program om både Nobel och Victoriadagen - här hittar du alla program på Svensk Dam!',
    },
  },
  [BRANDS.HANT]: {
    frontPage: {
      sections: ['new', 'shows', 'tags', 'trending'],
      pageTitle: 'De senaste videoklippen från Hänt',
      newsSectionTitle: 'SENASTE VIDEOS',
      showsSectionTitle: 'KUNGLIGA PROGRAM',
      trendingSectionTitle: 'MEST SEDDA',
      seoTitle: 'Hänt | Video',
      seoDescription:
        'Se alla videos inom nöje och kungligt på Hänt – allt från intervjuer på röda mattan till nyheter om kändisar och kungligheter.',
      description:
        'På Hänt hittar du nöjesrelaterade och kungliga intervjuer, videos och nyheter! Se intervjuer från röda mattan och fantastiska ögonblick från när Hänt träffar Sveriges hetaste kändisar. Vi har samlat alla Hänts videoklipp här så du håller dig uppdaterad med det senaste och inte missar något från nöjesvärlden!',
    },
    tagPage: {
      getDescription: (tagName: string) =>
        `Här kan du se du alla intervjuer och videos om ${tagName}. På Hänt hittar du videos, klipp och intervjuer om det senaste inom nöje och kungligt.`,
    },
    showsPage: {
      headline: 'Alla program på Hänt ELLER Våra program (det har de idag)',
      getShowDefaultDescription: (programName: string) =>
        `Här kan du se alla avsnitt av Hänts program ${programName}. Missa heller inte alla andra program och serier på Hänt!`,
      getShowSeoDescription: (programName: string) =>
        `Se alla avsnitt av ${programName} på Hänt. Och missa inte alla våra andra program och videos!`,
      allShowSeoDescription:
        'Här ser du alla Hänts program som bland annat Vad äter du när... och Röda mattan och självklart Exklusiva intervjuer!',
      description:
        'Här är alla program du kan se på Hänt! Vill du kanske titta på Röda mattan, Exklusiva intervjuer, eller Vad äter du när… där Hänt möter folkkära kändisar? Här hittar du alla program samlade på ett ställe!',
    },
  },
}[getSite()] ?? DEFAULT_CONFIG) as Config;
